import React from 'react';

import { HelpLink, LearnMoreArrow } from '../styles';
import { ButtonClickHandler, ButtonContent } from './types';
import { isValidHttpUrl } from './useVatixGuide';

// A stroked SVG instead of the ↗ glyph, which renders too thin to match the text weight.
export const LearnMoreLabel: React.FC = () => (
  <>
    Learn more{' '}
    <LearnMoreArrow aria-hidden="true">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path
          d="M3 9L9 3M9 3H4M9 3V8"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </LearnMoreArrow>
  </>
);

export const GuideHelpLink: React.FC<{
  helpLink: string | undefined;
  as?: React.ComponentType<React.ComponentPropsWithRef<'a'>>;
}> = ({ helpLink, as: As = HelpLink }) => {
  if (!helpLink || !isValidHttpUrl(helpLink)) {
    return null;
  }

  return (
    <As href={helpLink} target="_blank" rel="noreferrer">
      <LearnMoreLabel />
    </As>
  );
};

type ActionsViewProps = { 'data-with-divider'?: string } & React.ComponentPropsWithRef<'div'>;
export type GuideActionsView = {
  Actions: React.FC<React.PropsWithChildren<ActionsViewProps>>;
  PrimaryButton: React.FC<ButtonContent & React.ComponentPropsWithRef<'button'>>;
  SecondaryButton: React.FC<ButtonContent & React.ComponentPropsWithRef<'button'>>;
};

export const GuideActions: React.FC<
  React.PropsWithChildren<{
    view: GuideActionsView;
    content: { primary_button?: ButtonContent; secondary_button?: ButtonContent };
    withDivider?: boolean;
    onButtonClick: ButtonClickHandler;
  }>
> = ({ view: View, content, withDivider, onButtonClick, children }) => {
  if (!content.primary_button && !content.secondary_button && !children) {
    return null;
  }

  return (
    <View.Actions data-with-divider={withDivider ? 'true' : undefined}>
      {content.secondary_button && (
        <View.SecondaryButton
          text={content.secondary_button.text}
          action={content.secondary_button.action}
          onClick={(e) => onButtonClick(e, { ...content.secondary_button!, name: 'secondary_button' })}
        />
      )}
      {content.primary_button && (
        <View.PrimaryButton
          text={content.primary_button.text}
          action={content.primary_button.action}
          onClick={(e) => onButtonClick(e, { ...content.primary_button!, name: 'primary_button' })}
        />
      )}
      {children}
    </View.Actions>
  );
};
